import { PoleLimitData } from '../../../../../../api/theHive/noticeCoverage/types';
import { PoleLimit, PoleStatus } from './types';

export const mapPole = (pole: PoleLimitData): PoleLimit => ({
  id: pole.id,
  name: pole.name ?? '—',
  state: pole.uf,
  activeAccreditations: pole.active_accreditations,
  limit: pole.max_companies,
  waitlistCount: pole.waitlist_count,
});

export const buildDraftLimits = (poles: PoleLimit[]): Record<number, string> =>
  poles.reduce<Record<number, string>>(
    (drafts, pole) => ({
      ...drafts,
      [pole.id]: String(pole.limit),
    }),
    {}
  );

/** Occupancy in %, guarded against a zero limit (avoids NaN/Infinity). */
export const occupancyPct = (active: number, limit: number): number => {
  if (limit <= 0) return active > 0 ? 100 : 0;
  return (active / limit) * 100;
};

export const getStatus = (
  activeAccreditations: number,
  limit: number
): PoleStatus => {
  if (activeAccreditations >= limit) {
    return { color: 'error', label: 'Limite atingido' };
  }
  if (occupancyPct(activeAccreditations, limit) >= 90) {
    return { color: 'warning', label: 'Próximo do limite' };
  }
  return { color: 'success', label: 'Disponível' };
};
